export const snackBarDisplayTime = 3000;
export const mobileAvailabilityHeaderHeight = '56px';
export const defaultLeadingZeros = 5;
export const INTERSECTION_OBSERVER_OPTIONS = {
  root: null,
  rootMargin: '100px',
  threshold: 1,
} as const;

export const LAYOUT_SIZES = {
  searchBar: 40,
  integrationsBar: 140,
} as const;
